
const validationPatterns = {
    email: /^[^\s@]+@[^\s@]+\.[^\s@]+$/,
    mobile: /^[0-9]{10}$/,
    AZ: /[A-Z]/,
    az: /[a-z]/,
    number: /[0-9]/,
    anyChar: /[!@#$%^&*]/,
    alphabet: /^[a-zA-Z\s]*$/,
}

export const validateEmail = (email) => {
    if (!email) {
        return { valid: false, message: "Email Required" };
    }

    const emailPattern = validationPatterns.email;
    const result = emailPattern.test(email);
    return { valid: result, message: result ? "" : "Enter a valid email" }


}

export const validateMobile = (mobile) => {

    const mobilePattern = validationPatterns.mobile;
    return mobilePattern.test(mobile);
}

export const validateEmailOrMobile = (input) => {
    return validateEmail(input) || validateMobile(input);
};

export const validatePassword = (password) => {
    if (!password) {
        return { valid: false, message: "Password required" }
    }
    const AZ = validationPatterns.AZ;
    const az = validationPatterns.az;
    const number = validationPatterns.number;
    const anyChar = validationPatterns.anyChar;
    let result = password.length >= 8 && AZ.test(password) && az.test(password) && number.test(password) && anyChar.test(password);
    return { valid: result, message: result ? "" : "Enter valid password" }
};

export const validatePasswordforgot = (password) => {
  const AZ = validationPatterns.AZ;
  const az = validationPatterns.az;
  const number = validationPatterns.number;
  const anyChar = validationPatterns.anyChar;
  return (
    password.length >= 12 &&
    AZ.test(password) &&
    az.test(password) &&
    number.test(password) &&
    anyChar.test(password)
  );
};

export const validateNotEmpty = (text) => {
    if (typeof text === 'number') {
        return text > 0;
    }

    text = String(text);

    return text.length >= 1;
}

export const validateAlphabet = (text) => {
    return validationPatterns.alphabet.test(text);
}

export const validateMinLength = (text, minLength) => {
    return text.length >= minLength;
}


export const parseJwt = (token) => {
    const base64Url = token.split('.')[1];
    const base64 = base64Url.replace(/-/g, '+').replace(/_/g, '/');
    const jsonPayload = decodeURIComponent(
        atob(base64)
            .split('')
            .map(c => `%${('00' + c.charCodeAt(0).toString(16)).slice(-2)}`)
            .join('')
    );
    return JSON.parse(jsonPayload);
}